import { DEFAULT_TOP_LEVEL_SURFACE } from '../../../../../../constants/appConstants';
import { Surface } from '../../../../../specification/Surface';

export const getCaseBasementLevelsDefaultCount = (projectedRealBuiltSurface: Surface) =>
  projectedRealBuiltSurface.value <= DEFAULT_TOP_LEVEL_SURFACE ? 1 : 2;
